<template>

	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		:class="iconColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_6481_8334)">
			<path
				d="M6.00001 14.5C6.00001 14.8333 6.26668 15.1667 6.66668 15.1667H9.33334C9.73334 15.1667 10 14.8333 10 14.5V13.8333H6.00001V14.5ZM8.00001 1.83334C5.40001 1.83334 3.33334 3.9 3.33334 6.5C3.33334 8.1 4.13334 9.5 5.33334 10.3V11.8333C5.33334 12.1667 5.60001 12.5 6.00001 12.5H10C10.4 12.5 10.6667 12.1667 10.6667 11.8333V10.3C11.8667 9.43334 12.6667 8.03334 12.6667 6.5C12.6667 3.9 10.6 1.83334 8.00001 1.83334Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_6481_8334">
				<rect
					width="16"
					height="16"
					fill="white"
					transform="translate(0 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>
<script setup>
const props = defineProps({
	iconColor:{
		type:String,
		default:'#073B5D'
	}
}
);
</script>
